import { useDraggable } from '@dnd-kit/core';
import { Colors, Text } from 'basic-ui-lib';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import IcFolder from 'modules/media/assets/icons/IcFolder';
import { IMediaItem, MediaType } from 'modules/media/interfaces/api';
import styled from 'styled-components';

interface DraggableMediaProps {
  item: IMediaItem;
  onClick: () => void;
}
const DraggableMedia = ({item, onClick}: DraggableMediaProps) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `media-${item.id}`,
    data: {
      type: 'MEDIA',
      item,
    },
    disabled: item.type === MediaType.FOLDER,
  });

  return (
    <MediaCard
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      style={{
        cursor: item.type === MediaType.FOLDER ? 'default' : 'grab',
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      {item.type === MediaType.FOLDER ? (
        <IcFolder />
      ) : (
        <Zone>
          {/* {item.type === MediaType.VIDEO ? (
            <video src={item.url || undefined} className='media-video' muted playsInline={false} controls={false} controlsList='nodownload' />
          ) : item.type === MediaType.IMAGE ? (
            <img src={item.url || undefined} className='media-image' alt={item.name} />
          ) : null} */}
          {RenderMedia(item, 4, false)}
        </Zone>
      )}

      <Text body_1 medium left ellipsis lineClamp={2} style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
        {item.name}
      </Text>
    </MediaCard>
  );
};

export default DraggableMedia;

const MediaCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  min-width: 0;
`;

const Zone = styled.div`
  position: relative;
  height: 82.41px;
  background: ${Colors.neutral.text[3]};
  border-radius: 4px;

  .media-video,
  .media-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    border-radius: 4px;
  }
`;
